import { request } from '../helpers/request';
import { ApiKey } from '../helpers/types';

export interface CreateApiKeyPayload {
  name: string;
  expiresAt?: string;
}

export const apiKeysApi = {
  list: (projectId: string) =>
    request<ApiKey[]>(`/projects/${projectId}/api-keys`),

  create: (projectId: string, payload: CreateApiKeyPayload) =>
    request<ApiKey>(`/projects/${projectId}/api-keys`, {
      method: 'POST',
      body: payload,
    }),

  revoke: (projectId: string, apiKeyId: string) =>
    request<void>(`/projects/${projectId}/api-keys/${apiKeyId}`, {
      method: 'DELETE',
    }),
};
